export class ADCreateUserModel {
  Email: string;
  Password: string
  link: string
  constructor(init?: Partial<ADCreateUserModel>) {
    Object.assign(this, init);
  }
}
